import React from 'react';

interface AddressModalProps {
  mode: 'create' | 'edit';
  form: any;
  setForm: (f: any) => void;
  error: string | null;
  onSubmit: (e: React.FormEvent) => void;
  onCancel: () => void;
  states: string[];
}

export default function AddressModal({ mode, form, setForm, error, onSubmit, onCancel, states }: AddressModalProps) {
  return (
    <form onSubmit={onSubmit} style={{ background: '#fff', padding: 32, borderRadius: 12, minWidth: 320, maxWidth: 600, width: '100%', boxShadow: '0 2px 16px rgba(0,0,0,0.12)' }}>
      <h3 style={{ fontSize: 20, fontWeight: 700, marginBottom: 16 }}>{mode === 'create' ? 'New Address' : 'Edit Address'}</h3>
      {error && <div style={{ color: 'red', marginBottom: 12 }}>{error}</div>}
      <input placeholder="Nickname" value={form.nickname} onChange={e => setForm((f: any) => ({ ...f, nickname: e.target.value }))} required style={{ marginBottom: 10, width: '100%', padding: 8, boxSizing: 'border-box' }} />
      <input placeholder="Address Line 1" value={form.address_line1} onChange={e => setForm((f: any) => ({ ...f, address_line1: e.target.value }))} required style={{ marginBottom: 10, width: '100%', padding: 8, boxSizing: 'border-box' }} />
      <input placeholder="Address Line 2 (optional)" value={form.address_line2} onChange={e => setForm((f: any) => ({ ...f, address_line2: e.target.value }))} style={{ marginBottom: 10, width: '100%', padding: 8, boxSizing: 'border-box' }} />
      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        <input
          placeholder="City"
          value={form.city}
          onChange={e => setForm((f: any) => ({ ...f, city: e.target.value }))}
          required
          style={{ flex: 3, padding: 8, boxSizing: 'border-box' }}
        />
        <select
          value={form.state}
          onChange={e => setForm((f: any) => ({ ...f, state: e.target.value }))}
          required
          style={{ flex: 1, padding: 8, boxSizing: 'border-box' }}
        >
          <option value="">State</option>
          {states.map(s => <option key={s} value={s}>{s}</option>)}
        </select>
        <input
          placeholder="Postal Code"
          value={form.postal_code}
          onChange={e => setForm((f: any) => ({ ...f, postal_code: e.target.value }))}
          required
          style={{ flex: 1, padding: 8, boxSizing: 'border-box' }}
        />
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
        <button type="button" onClick={onCancel} style={{ padding: '8px 16px', background: '#e5e7eb', color: '#333', border: 'none', borderRadius: 6 }}>Cancel</button>
        <button type="submit" style={{ padding: '8px 16px', background: '#2563eb', color: '#fff', border: 'none', borderRadius: 6, fontWeight: 600 }}>{mode === 'create' ? 'Create' : 'Save'}</button>
      </div>
    </form>
  );
}
